import { Component, Input, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  ConsolidadoService,
  DepositoInformacionAdicionalModeloMLS,
  DepositoService,
  ModeloDepositoMS,
  ObtenerConsolidadoME,
  ObtenerConsolidadoMS,
  ObtenerInformacionAdicionalDepositoME,
  ObtenerInformacionAdicionalDepositoMS
} from 'src/app/open-api';
import { AuthService } from '../../services/auth.service';
import { UserModel } from '../../models/user.model';

@Component({
  selector: 'app-deposito-informacion',
  templateUrl: './deposito-informacion.component.html',
  styleUrls: ['./deposito-informacion.component.scss']
})
export class DepositoInformacionComponent implements OnInit {
  @Input() set SecuencialDeposito(secuencial: number) {
    this.secuencialDeposito = secuencial;
    this.ObtenerInformacion();
  }
  @Input() set MontoDeposito(deposito:number){
    this.montoDeposito = deposito;
  };


  secuencialDeposito = 0;
  montoDeposito=0;
  informacion?: ObtenerInformacionAdicionalDepositoMS;
  componentes: DepositoInformacionAdicionalModeloMLS[] = [];
  cantidad = 0;
  pagina = 1;
  paginaTamanio = 3;


  constructor(
    private depositoService: DepositoService,
    private spinner: NgxSpinnerService,

  ) { }

  ngOnInit(): void {

  }

  ListarInformacion(): void {
    this.componentes = (this.informacion?.componentesDeposito || [])
      .slice((this.pagina - 1) * this.paginaTamanio, (this.pagina - 1) * this.paginaTamanio + this.paginaTamanio);
  }

  ObtenerInformacion(): void {
    this.spinner.show();
    const parametro: ObtenerInformacionAdicionalDepositoME = {
      secuencialDeposito: this.secuencialDeposito
    };
    this.depositoService.apiV10DepositoObtenerInformacionAdicionalDepositoPost(parametro).subscribe(respuesta => {
      this.informacion = respuesta;
      this.cantidad = (this.informacion?.componentesDeposito?.length || 0);
      this.ListarInformacion();
      this.spinner.hide();
    });
  }



}
